// components/pages/public/DeliverySignPage.jsx
import React from 'react';
import { CheckCircle2, FileSignature, AlertCircle, Loader2, ShieldCheck, User } from 'lucide-react';
import { SignaturePad } from '../../../common/SignaturePad';
import { withRouter } from '../../../../hoc/withRouter';
import { getDeliverySignatureByToken, submitWinnerSignature } from '../../../dashboard/pages/AuctionApproval/services/auctionApprovalServices';
import i18n from '../../../../i18n';

class DeliverySignPage extends React.Component {
  state = {
    loading: true,
    info: null,
    error: null,
    submitting: false,
    done: false,
    collector_name: '',
  };
  padRef = React.createRef();

  componentDidMount() {
    this.loadInfo();
  }

  async loadInfo() {
    const { token } = this.props.params;
    const response = await getDeliverySignatureByToken(token);
    if (response.success) {
      this.setState({ info: response.data, loading: false });
    } else {
      this.setState({ error: response.message || 'Invalid or expired link.', loading: false });
    }
  }

  submit = async () => {
    const signature = this.padRef.current && this.padRef.current.getSignature();
    if (!signature) {
      this.setState({ error: 'Please sign before submitting.' });
      return;
    }
    if (!this.state.collector_name.trim()) {
      this.setState({ error: 'Please enter the name of the person collecting this item.' });
      return;
    }
    this.setState({ submitting: true, error: null });
    const { token } = this.props.params;
    const response = await submitWinnerSignature(token, {
      signature,
      collector_name: this.state.collector_name.trim(),
    });
    if (response.success) {
      this.setState({ done: true, submitting: false });
    } else {
      this.setState({ error: response.message || 'Failed to submit signature.', submitting: false });
    }
  };

  render() {
    const { loading, info, error, done, submitting, collector_name } = this.state;

    if (loading) {
      return (
        <div className="public-sign-page">
          <div className="public-sign-page__loading">
            <Loader2 className="spin" size={22} />
          </div>
        </div>
      );
    }

    if (done) {
      return (
        <div className="public-sign-page">
          <div className="public-sign-page__done">
            <CheckCircle2 size={40} />
            <div>Thank you — your signature has been recorded.</div>
          </div>
        </div>
      );
    }

    if (error && !info) {
      return (
        <div className="public-sign-page">
          <div className="public-sign-page__error-page">
            <AlertCircle size={28} />
            <div>{i18n.t(error)}</div>
          </div>
        </div>
      );
    }

    return (
      <div className="public-sign-page">
        <div className="public-sign-page__card">
          <div className="public-sign-page__header">
            <span className="public-sign-page__eyebrow">
              <ShieldCheck size={14} /> Delivery Clearance
            </span>
            <h2 className="public-sign-page__title">Delivery Signature — MZAD {info.auction_id}</h2>
            <p className="public-sign-page__subtitle">{info.auction_title}</p>
          </div>

          <div className="public-sign-page__body">
            <div className="public-sign-page__meta">
              <div className="public-sign-page__meta-item">
                <span className="public-sign-page__meta-label">Group</span>
                <span className="public-sign-page__meta-value">{info.group_name}</span>
              </div>
              <div className="public-sign-page__meta-item">
                <span className="public-sign-page__meta-label">Winner</span>
                <span className="public-sign-page__meta-value">{info.winner_name}</span>
              </div>
            </div>

            <div className="public-sign-page__instructions">
              <FileSignature size={18} />
              <span>By signing below, you confirm receipt/approval of the delivery for the above item.</span>
            </div>

            <div className="public-sign-page__form-group">
              <label className="public-sign-page__form-label" htmlFor="collector_name">
                <User size={14} /> Name of Person Collecting
              </label>
              <input
                id="collector_name"
                type="text"
                className="public-sign-page__input"
                placeholder="Enter the name of the person collecting this item"
                value={collector_name}
                onChange={(e) => this.setState({ collector_name: e.target.value, error: null })}
                disabled={submitting}
              />
              <span className="public-sign-page__form-hint">
                If someone other than the bidder is picking up the item, enter their name here.
              </span>
            </div>

            <div className="public-sign-page__signature-label">
              <span>Your Signature</span>
            </div>

            <SignaturePad ref={this.padRef} disabled={submitting} />

            {error && (
              <div className="public-sign-page__error">
                <AlertCircle size={16} />
                <span>{error}</span>
              </div>
            )}

            <button className="public-sign-page__submit" onClick={this.submit} disabled={submitting}>
              {submitting ? (
                <>
                  <Loader2 className="spin" size={16} /> Submitting...
                </>
              ) : (
                <>
                  <CheckCircle2 size={18} /> Submit Signature
                </>
              )}
            </button>

            <p className="public-sign-page__footnote">This link is unique to you and will expire after use.</p>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(DeliverySignPage);